module.exports = __webpack_public_path__ + "static/richmond-bg-354e84c6611ba6d823777a0415b09c30.png";